import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {DepotModel} from "../../../../depots/angular/models/depot.model";

@Component({
  standalone: false,
  selector: 'app-depot-link',
  templateUrl: './depot-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepotLinkComponent {

  @Input() depot: DepotModel;
  @Input() address: any;
  @Input() phone: string;
  @Input() additionalPhone: string;
  @Input() isHideTooltip: boolean;

  public hasDepotsGetPermission: boolean;

  constructor() {
  }


}
